import { Routes } from '@angular/router';
import { Layout } from './core/layout/layout';
import { Dashboard } from './features/dashboard/dashboard';
import { canActivateAuthRole } from './core/auth/auth.guard';


export const routes: Routes = [
  {
    path: '',
    component: Layout,
  canActivate: [canActivateAuthRole],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        component: Dashboard,
        canActivate: [canActivateAuthRole],
        data: { roles: ['admin', 'deposito', 'planta'] }
      },
      {
        path: 'material',
        loadChildren: () => import('./features/material/material.routes').then(m => m.MATERIAL_ROUTES),
        canActivate: [canActivateAuthRole],
        data: { roles: ['admin', 'deposito', 'planta'] }
      },
      {
        path: 'equipo',
        loadChildren: () => import('./features/equipo/equipo.routes').then(m => m.EQUIPO_ROUTES),
        canActivate: [canActivateAuthRole],
        data: { roles: ['admin', 'deposito', 'planta'] }
      },
      {
        path: 'pedido',
        loadChildren: () => import('./features/pedido/pedido.routes').then(m => m.PEDIDO_ROUTES),
        canActivate: [canActivateAuthRole],
        data: { roles: ['admin', 'deposito', 'planta'] }
      },
      {
        path: 'orden-retiro',
        loadChildren: () => import('./features/orden-retiro/orden-retiro.routes').then(m => m.ORDEN_RETIRO_ROUTES),
        data: { roles: ['admin', 'deposito', 'planta', 'operario'] }
      },
    ]
  }
];